import { observable } from "mobx";
import { Type } from "class-transformer";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChangeVehicleRegistrationRequest {
  /**
   * Changed country ID.
   */
  @observable
  countryId!: string;

  /**
   * Changed license plate.
   */
  @observable
  licensePlate!: string;

  /**
   * Official record ID.
   */
  @observable
  officialRecordId!: string;

  /**
   * Submission date.
   */
  @observable
  @Type(() => Date)
  submissionDate!: Date;
}
